<template>
  <v-container>
    <h1 class="text-center">Giveaway</h1>
    <v-toolbar flat>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-toolbar>

    <!-- Desktop: Data Table -->
    <v-data-table
      v-if="!$vuetify.breakpoint.smAndDown"
      :search="search"
      :headers="headers"
      :items="giveaways"
      sort-by="calories"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-dialog v-model="dialog" max-width="80vw">
          <v-card>
            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="formValid" lazy-validation>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.title"
                        label="Titel"
                        :rules="[v => !!v || 'Titel is required']"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        v-model="editedItem.description"
                        label="Beschreibung"
                        rows="1"
                        auto-grow
                        :rules="[v => !!v || 'Beschreibung is required']"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="4">
                      <v-checkbox v-model="editedItem.confirm_buyin" label="Kauf bestätigung" />
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        v-model="editedItem.cost_per_ticket"
                        label="Ticketkosten"
                        type="Number"
                        :rules="rulesPositiveNumber"
                        min="1"
                        required
                      />
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        v-model="editedItem.ticker_per_user"
                        label="Höchstzahl der Tickets pro Benutzer"
                        type="Number"
                        :rules="rulesPositiveNumber"
                        min="1"
                        required
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-label>Subscriber Multiplikator ({{ editedItem.sub_multiplier }}x)</v-label>
                      <v-slider
                        :hint="sliderDescription"
                        persistent-hint
                        v-model="editedItem.sub_multiplier"
                        step="1"
                        max="10"
                        min="1"
                      ></v-slider>
                    </v-col>
                  </v-row>
                  <v-snackbar v-model="ErrorFlag" timeout="3000" color="red">
                    Überprüfe die roten Felder!
                    <template v-slot:actions>
                      <v-btn color="pink" variant="text" @click="ErrorFlag = false">Close</v-btn>
                    </template>
                  </v-snackbar>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="save" :loading="saving">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>

      <template v-slot:[`item.confirm_buyin`]="{ item }">
        <div>{{ item.confirm_buyin === 1 ? 'Ja' : 'Nein' }}</div>
      </template>
      <template v-slot:[`item.started`]="{ item }">
        <div v-if="item.started">{{ new Date(item.started * 1000).toLocaleString('de-De') }}</div>
        <i v-else>-</i>
      </template>
      <template v-slot:[`item.stopped`]="{ item }">
        <div v-if="item.stopped">{{ new Date(item.stopped * 1000).toLocaleString('de-De') }}</div>
        <i v-else>-</i>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top color="success">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="mr-2" @click="editItem(item)" v-bind="attrs" v-on="on">mdi-pencil</v-icon>
          </template>
          <span>Editieren!</span>
        </v-tooltip>
        <v-tooltip top color="warning">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="mr-2" @click="copyItem(item)" v-bind="attrs" v-on="on">mdi-content-copy</v-icon>
          </template>
          <span>Kopieren!</span>
        </v-tooltip>
        <v-tooltip top color="error">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              :disabled="item.started !== null && item.stopped === null"
              @click="deleteItem(item)"
              v-bind="attrs" v-on="on"
            >mdi-delete</v-icon>
          </template>
          <span>Löschen!</span>
        </v-tooltip>
        <v-tooltip top color="success">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              @click="startItem(item)"
              :disabled="item.started !== null"
              v-bind="attrs" v-on="on"
            >mdi-play</v-icon>
          </template>
          <span>Starten!</span>
        </v-tooltip>
        <v-tooltip top color="error">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              @click="stopItem(item)"
              :disabled="item.started === null || item.stopped !== null"
              v-bind="attrs" v-on="on"
            >mdi-stop</v-icon>
          </template>
          <span>Stoppen!</span>
        </v-tooltip>
        <v-tooltip top color="success">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              @click="winner ? dialogWinner = true : pickWinner(item)"
              :disabled="item.started === null || item.stopped === null"
              v-bind="attrs" v-on="on"
            >mdi-ticket</v-icon>
          </template>
          <span>Gewinner ziehen!</span>
        </v-tooltip>
        <a :href="`/giveaway/${item.publicid}`" target="_blank">
          <v-tooltip top color="success">
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on">mdi-link</v-icon>
            </template>
            <span>Link zum Giveaway!</span>
          </v-tooltip>
        </a>
      </template>
    </v-data-table>

    <!-- Mobile: Card List -->
    <template v-else>
      <v-card
        v-for="item in mobileItems"
        :key="item.id"
        class="mb-3"
        outlined
      >
        <v-card-title class="d-flex justify-space-between align-center py-2">
          <span class="giveaway-title">{{ item.title }}</span>
          <v-chip x-small :color="giveawayStatusColor(item)" dark>{{ giveawayStatus(item) }}</v-chip>
        </v-card-title>
        <v-card-subtitle class="pb-0">
          <v-chip x-small class="mr-1">{{ item.cost_per_ticket }} Pts/Ticket</v-chip>
          <v-chip x-small class="mr-1">Max {{ item.ticker_per_user }} Tickets</v-chip>
          <v-chip x-small color="info" v-if="item.sub_multiplier > 1">{{ item.sub_multiplier }}x Sub</v-chip>
        </v-card-subtitle>
        <v-card-text class="pt-2">
          <div class="body-2 giveaway-desc">{{ item.description }}</div>
          <div class="caption grey--text mt-1" v-if="item.started">
            Start: {{ new Date(item.started * 1000).toLocaleString('de-De') }}
          </div>
          <div class="caption grey--text" v-if="item.stopped">
            Ende: {{ new Date(item.stopped * 1000).toLocaleString('de-De') }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn icon @click="editItem(item)">
            <v-icon color="success">mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon @click="copyItem(item)">
            <v-icon color="warning">mdi-content-copy</v-icon>
          </v-btn>
          <v-btn icon @click="deleteItem(item)" :disabled="item.started !== null && item.stopped === null">
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
          <v-btn icon @click="startItem(item)" :disabled="item.started !== null">
            <v-icon color="success">mdi-play</v-icon>
          </v-btn>
          <v-btn icon @click="stopItem(item)" :disabled="item.started === null || item.stopped !== null">
            <v-icon color="error">mdi-stop</v-icon>
          </v-btn>
          <v-btn icon @click="winner ? dialogWinner = true : pickWinner(item)" :disabled="item.started === null || item.stopped === null">
            <v-icon color="success">mdi-ticket</v-icon>
          </v-btn>
          <v-btn icon :href="`/giveaway/${item.publicid}`" target="_blank">
            <v-icon>mdi-link</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-alert v-if="mobileItems.length === 0" type="info" class="mt-2">
        Keine Giveaways gefunden.
      </v-alert>

      <!-- Mobile Edit Dialog (fullscreen) -->
      <v-dialog v-model="dialog" fullscreen>
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Giveaway bearbeiten</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn text @click="save" :loading="saving">Speichern</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-form ref="form" v-model="formValid" lazy-validation>
            <v-container class="pa-4">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.title"
                    label="Titel"
                    :rules="[v => !!v || 'Titel is required']"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="editedItem.description"
                    label="Beschreibung"
                    rows="3"
                    auto-grow
                    :rules="[v => !!v || 'Beschreibung is required']"
                    outlined
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-checkbox v-model="editedItem.confirm_buyin" label="Kauf bestätigung" />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="editedItem.cost_per_ticket"
                    label="Ticketkosten"
                    type="Number"
                    :rules="rulesPositiveNumber"
                    min="1"
                    required
                    outlined
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="editedItem.ticker_per_user"
                    label="Max. Tickets pro Benutzer"
                    type="Number"
                    :rules="rulesPositiveNumber"
                    min="1"
                    required
                    outlined
                  />
                </v-col>
                <v-col cols="12">
                  <v-label>Subscriber Multiplikator ({{ editedItem.sub_multiplier }}x)</v-label>
                  <v-slider
                    :hint="sliderDescription"
                    persistent-hint
                    v-model="editedItem.sub_multiplier"
                    step="1"
                    max="10"
                    min="1"
                  ></v-slider>
                </v-col>
              </v-row>
            </v-container>
            <v-snackbar v-model="ErrorFlag" timeout="3000" color="red">
              Überprüfe die roten Felder!
              <template v-slot:actions>
                <v-btn color="pink" variant="text" @click="ErrorFlag = false">Close</v-btn>
              </template>
            </v-snackbar>
          </v-form>
        </v-card>
      </v-dialog>
    </template>

    <!-- Shared: Delete Confirm Dialog -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Sicher dieses Giveaway löschen?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Nein!</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">Ja!</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Shared: Winner Dialog -->
    <v-dialog v-model="dialogWinner" max-width="500px">
      <v-card class="text-center">
        <v-card-title class="text-h5">
          Der Gewinner dieses Giveaways ist:<br>{{ winner }}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="pickWinner(safeWinnerItem)">Reroll!</v-btn>
          <v-btn color="blue darken-1" text @click="closeGiveawayWinnerDialog">Verstanden!</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-btn color="success" class="mr-4 mt-3" @click="newGiveaway">
      neues Giveaway
    </v-btn>
  </v-container>
</template>

<script>

import BackendService from '@/services/BackendService';

export default {
  name: 'GiveawayView',

  data: () => ({
    safeWinnerItem: {},
    winner: '',
    search: '',
    dialog: false,
    dialogDelete: false,
    dialogWinner: false,
    saving: false,
    giveaways: [],
    valid: true,
    sliderDescription: 'Abonnentengewinnchancemultiplikator',
    headers: [
      { text: 'Titel', value: 'title', align: 'center' },
      { text: 'Beschreibung', value: 'description', align: 'center' },
      { text: 'Ticketkosten', value: 'cost_per_ticket', align: 'right' },
      { text: 'Ticket/Benutzer', value: 'ticker_per_user', align: 'right' },
      { text: 'Bestätigen', value: 'confirm_buyin', align: 'center' },
      { text: 'Sub-Multiplikator', value: 'sub_multiplier', align: 'right' },
      { text: 'Start', value: 'started', align: 'center' },
      {
        text: 'Stop', value: 'stopped', align: 'center', sortable: false,
      },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    editedIndex: -1,
    editedItem: {
    },
    defaultItem: {
    },
    formValid: false,
    rulesPositiveNumber: [
      (v) => !!v || 'Feld darf nicht leer sein',
      (v) => !Number.isNaN(v) || 'Nur Zahlen sind erlaubt',
      (v) => parseFloat(v) > 0 || 'Zahl muss positiv sein',
      (v) => parseFloat(v) <= 10000000 || 'Zahl darf höchstens 10.000.000 sein',
    ],
    rulesWith0: [
      (v) => (v !== null && (v) !== undefined) || 'Feld darf nicht leer sein',
      (v) => !Number.isNaN(v) || 'Nur Zahlen sind erlaubt',
      (v) => parseFloat(v) >= 0 || 'Zahl muss positiv sein',
      (v) => parseFloat(v) <= 10000000 || 'Zahl darf höchstens 10.000.000 sein',
    ],
    ErrorFlag: false,
  }),
  components: {
  },
  mounted() {
    BackendService.loadGiveaways().then((data) => {
      this.giveaways = data.data;
    });
  },
  computed: {
    mobileItems() {
      if (!this.search) return this.giveaways;
      const s = this.search.toLowerCase();
      return this.giveaways.filter((g) => (g.title && g.title.toLowerCase().includes(s))
        || (g.description && g.description.toLowerCase().includes(s)));
    },
  },
  methods: {
    giveawayStatus(item) {
      if (item.stopped) return 'Beendet';
      if (item.started) return 'Läuft';
      return 'Entwurf';
    },
    giveawayStatusColor(item) {
      if (item.stopped) return 'error';
      if (item.started) return 'success';
      return 'grey';
    },
    editItem(item) {
      this.editedIndex = this.giveaways.indexOf(item);
      this.editedItem = { ...item };
      this.dialog = true;
    },
    copyItem(item) {
      this.editedItem = { ...item };
      delete this.editedItem.id;
      this.dialog = true;
    },
    newGiveaway() {
      this.editedIndex = -1;
      this.editedItem = { };
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },
    deleteItemConfirm() {
      BackendService.deleteGiveaway({
        id: this.editedItem.id,
      }).then((data) => {
        this.giveaways = data.data;
        this.closeDelete();
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },
    deleteItem(item) {
      this.editedIndex = this.giveaways.indexOf(item);
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },
    startItem(item) {
      BackendService.startGiveaway({
        id: item.id,
        title: item.title,
      }).then((data) => {
        this.giveaways = data.data;
      });
    },
    stopItem(item) {
      BackendService.stopGiveaway({
        id: item.id,
        title: item.title,
      }).then((data) => {
        this.giveaways = data.data;
      });
    },
    pickWinner(item) {
      if (this.dialogWinner === true) this.dialogWinner = false;
      BackendService.pickWinnerGiveaway({
        id: item.id,
      }).then((data) => {
        const targetArray = data.data.find((item1) => item1.id === item.id);
        this.giveaways = data.data;
        this.winner = targetArray.winner;
        this.safeWinnerItem = item;
        this.dialogWinner = true;
      });
    },
    closeGiveawayWinnerDialog() {
      this.dialogWinner = false;
    },
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        BackendService.saveGiveaway(
          this.editedItem,
        ).then((data) => {
          this.giveaways = data.data;
        }).catch(() => {
          alert('nö!');
        }).finally(() => {
          this.saving = false;
          this.close();
        });
      } else this.ErrorFlag = true;
    },
  },
};
</script>

<style scoped>
.giveaway-title {
  font-size: 1rem;
  font-weight: 500;
  word-break: break-word;
}
.giveaway-desc {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
